module.exports = __webpack_public_path__ + "static/media/161007-DSC05046-21_Small.1b60197e.jpg";